import { render, staticRenderFns } from "./DefectReportDialog.vue?vue&type=template&id=47d1461e&scoped=true&"
import script from "./DefectReportDialog.vue?vue&type=script&lang=js&"
export * from "./DefectReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./DefectReportDialog.vue?vue&type=style&index=0&id=47d1461e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d1461e",
  null
  
)

export default component.exports